<script>
import { dealService } from "../../services";
import { required } from "vuelidate/lib/validators";
import config from "../../config";
import { error_message, success_message } from "../../Helper/helper";
export default {
  components: { dealService },
  data() {
    return {
      products: "",
      subProducts: [],
      typeform: {
        product_id: "",
        subProduct_id: "",
        status: 1,
        user_type: "",
      },
    };
  },
  validations: {
    typeform: {
      product_id: {
        required,
      },
      subProduct_id: {
        required,
      },
      status: {
        required,
      },
      user_type: {
        required,
      },
    },
  },
  methods: {
    getProducts() {
      dealService.getProducts().then((response) => {
        if (response.data.code === 200) {
          // this.products = response.data.result;
          this.products = response.data.result.sort((a, b) => {
            return a.item_name.localeCompare(b.item_name);
          });
        }
      });
    },

    getSubProduct(event) {
      this.subProduct_id = event.target.value;
      dealService
        .getSubProducts({ subProduct_id: this.subProduct_id })
        .then((response) => {
          if (response.data.code === 200) {
            // this.subProducts = response.data.result;
            this.subProducts = response.data.result.sort((a, b) => {
              return a.sub_product_name.localeCompare(b.sub_product_name);
            });
          }
        });
    },

    addDeal() {
      this.$v.typeform.$touch();
      if (this.$v.typeform.$invalid) {
        return;
      } else {
        const fd = new FormData();
        dealService.storeDeal({ ...this.typeform }).then((response) => {
          if (response.data.code === 200) {
            success_message(response.data.message);
            this.$router.push({ name: "deal-list" });
          } else {
            error_message(response.data.message);
          }
        });
      }
    },
  },

  mounted() {
    this.getProducts();
  },
};
</script>

<template>
  <form action="" @submit.prevent="addDeal">
    <div class="card">
      <div class="card-body">
        <p class="card-title-desc"></p>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="required">{{
                trans.trans("__JSON__.Product")
              }}</label>
              <select
                v-model="$v.typeform.product_id.$model"
                class="custom-select"
                id="product_id"
                name="product_id"
                @change="getSubProduct($event)"
                :class="{ 'is-invalid': $v.typeform.product_id.$error }"
              >
                <option value="">
                  {{ trans.get("__JSON__.Select Product") }}
                </option>
                <option
                  v-for="product in products"
                  :key="product.id"
                  v-text="product.item_name"
                  :value="product.id"
                ></option>
              </select>
              <div
                v-if="$v.typeform.product_id.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.typeform.product_id.required">{{
                  trans.get("__JSON__.Please select product")
                }}</span>
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="form-group">
              <label class="required">{{
                trans.trans("__JSON__.Sub Product")
              }}</label>
              <select
                class="custom-select"
                id="subProduct_id"
                name="subProduct_id"
                v-model="typeform.subProduct_id"
                :class="{ 'is-invalid': $v.typeform.subProduct_id.$error }"
              >
                <option value="">
                  {{ trans.get("__JSON__.Select Sub Product") }}
                </option>
                <option
                  v-for="subProduct in subProducts"
                  :key="subProduct.id"
                  v-text="subProduct.sub_product_name"
                  :value="subProduct.subproduct_id"
                ></option>
              </select>
              <div
                v-if="$v.typeform.subProduct_id.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.typeform.subProduct_id.required">{{
                  trans.get("__JSON__.Please select SubProduct")
                }}</span>
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="form-group">
              <label class="required">{{
                trans.trans("__JSON__.Customer Type")
              }}</label>
              <select
                class="custom-select"
                id="user_type"
                name="user_type"
                v-model="typeform.user_type"
                :class="{ 'is-invalid': $v.typeform.user_type.$error }"
              >
                <option value="">
                  {{ trans.get("__JSON__.Select Customer Type") }}
                </option>

                <option value="0">
                  {{ trans.get("__JSON__.All") }}
                </option>

                <option value="1">
                  {{ trans.get("__JSON__.Private") }}
                </option>

                <option value="2">
                  {{ trans.get("__JSON__.Business") }}
                </option>
              </select>
              <div v-if="$v.typeform.user_type.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.user_type.required">{{
                  trans.get("__JSON__.Please select Customer Type")
                }}</span>
              </div>
            </div>
          </div>

          <div class="col-sm-6 vendor-status">
            <b-form-group
              id="input-group-1"
              :label="trans.get('__JSON__.Status')"
              label-for="status"
            >
              <label class="switch">
                <input
                  type="checkbox"
                  id="togBtn"
                  name="status"
                  class="switch-on"
                  true-value="1"
                  false-value="0"
                  v-model="typeform.status"
                />
                <div class="slider round">
                  <span class="on">{{ trans.get("__JSON__.Active") }}</span>
                  <span class="off">{{ trans.get("__JSON__.Inactive") }}</span>
                </div>
              </label>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <button class="btn btn-primary mr-1 mt-3">
              {{ trans.get("__JSON__.Add Deal") }}
            </button>
            <!-- <b-button
              @click="$router.go(-1)"
              type="button"
              variant="secondary"
              class="mt-3"
              >{{ trans.get("__JSON__.Cancel") }}</b-button
            > -->
            <router-link
              :to="{name:'deal-list'}"
            >
              <b-button
                type="button"
                variant="secondary"
                class="mt-3"
                >{{ trans.get("__JSON__.Cancel") }}</b-button
              >
            </router-link>  
          </div>
        </div>
      </div>
    </div>
  </form>
</template>